import { useContext, useEffect, useState } from "react";
import { LeftSidebar, RightSidebar } from "./ui/Layout";
import { NavGroupItem } from "./ui/Layout/LeftSidebar/types";
import { AppContext } from "./AppContext";
import { HookTriggers } from "./plugins/types";
import { ListItemsHooks } from "./plugins/types";
import { triggerAsyncHook } from "./plugins/client";
import CmdK from "./ui/CommunicationView/CmdK";
import "./desktop/desktopFrame.css"; // Launch OS for Mac only (html.ld-solo); no effect in a browser
import { getSessionToken } from "./api/auth";
import { getBasicUserInfo } from "./api/auth";
import { CopilotWrapper } from "./Apps/AITools/CopilotWrapper";

export const MainContentWrapper = ({ children }) => {
  const [menuItems, setMenuItems] = useState<NavGroupItem[]>([]);
  const [bottomMenuItems, setBottomMenuItems] = useState<NavGroupItem[]>([]);
  const [userInfo, setUserInfo] = useState<any>({});
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const contextObj = useContext(AppContext);

  const [copilotCampaignName, setCopilotCampaignName] = useState();
  const [copilotCampaignId, setCopilotCampaignId] = useState(
    contextObj.copilotSettings?.id
  );

  const {
    copilotOpen,
    copilotSettings = {},
    disableRightSidebar,
    sidebarOpen = true,
  } = contextObj;

  const loadInAllMenuItems = async () => {
    // Trigger the onListItems hook to get the menu items
    const menuItemsFromPlugin = await triggerAsyncHook(
      HookTriggers.onListItems,
      {
        id: ListItemsHooks.APP_DRAWER,
        position: "top",
      },
      null,
      null,
      contextObj
    );

    // Set the menu items state
    setMenuItems(menuItemsFromPlugin);

    // Bottom app-drawer slot (pinned items above the Support section)
    const bottomItemsFromPlugin = await triggerAsyncHook(
      HookTriggers.onListItems,
      {
        id: ListItemsHooks.APP_DRAWER,
        position: "bottom",
      },
      null,
      null,
      contextObj
    );
    setBottomMenuItems(bottomItemsFromPlugin);
  };

  const checkToken = () => {
    const token = getSessionToken();
    const isUserloggedIn = Boolean(token);
    setIsLoggedIn(isUserloggedIn);

    if (isUserloggedIn) {
      const response = getBasicUserInfo();
      console.log("Basic User Info", response);
      setUserInfo(response);
    }
  };

  useEffect(() => {
    loadInAllMenuItems();
  }, [contextObj]);

  useEffect(() => {
    checkToken();
  }, []);

  const sidebarType = "minimal";

  return (
    <CmdK>
      {/* Width must be viewport MINUS the sidebar — it's offset right by the sidebar
          margin (ml), so a full 100vw width pushes the right edge off-screen and clips
          full-width content (BUG-06). Subtract the matching sidebar width. */}
      <div className={`main-content flex-1 h-[100vh] ${sidebarType === "minimal" ? "ml-[60px] w-[calc(100vw-60px)] max-w-[calc(100vw-60px)]" : "ml-[212px] w-[calc(100vw-212px)] max-w-[calc(100vw-212px)]"}`}>
        {/* {JSON.stringify({isLoggedIn,sidebarOpen})} */}
        {isLoggedIn && (
          <LeftSidebar
            type={sidebarType}
            menuItems={menuItems}
            bottomMenuItems={bottomMenuItems}
            avatarSettings={userInfo}
            showLogo={false}
            showSupportSection={userInfo?.permissions?.includes("launchOS")}
            // showCopilotButton={userInfo?.permissions?.includes("copilot")}
          />
        )}

        {copilotOpen && !window.location.pathname.includes('/copilot') ? (
          <CopilotWrapper
            id={copilotCampaignId}
            setCampaignId={setCopilotCampaignId}
            setCampaignName={setCopilotCampaignName}
            {...copilotSettings}
          >
            {children}
          </CopilotWrapper>
        ) : (
          children
        )}

        {/* Render the Right Sidebar if not disabled */}
        {!disableRightSidebar && (
          <RightSidebar
            notifications={false}
            activities={false}
            contacts={false}
            chat={true}
            // pageSettings={topBar?.page}
          />
        )}
      </div>
    </CmdK>
  );
};
